import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { formValueSelector } from 'redux-form';
import moment from 'moment';

import { ReportGeneration } from 'Common/ObjectHelper';
import {
  MasterRosterFieldEnum as Fields,
  ReportFieldEnum as ReportFields,
} from 'Common/FieldEnum';
import { Filter, Main } from 'Containers/';
import { MasterRosterForm } from './components/MasterRosterForm';
import { getInitialData } from './state/masterroster/actions';
import { MASTER_ROSTER_FORM_NAME } from 'Common/FormEnum';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';
import { ReportFieldEnum } from 'Common/FieldEnum';
import {
  asOfOptions,
  sortByOptions,
  provisionTypeOptions,
  statusOptionModelParamMap,
  filterMethodEnums,
  statusOptions,
} from './helpers/constants';
import {
  getReport,
  clearReport,
  clearErrors,
  getExcelFile,
  clearExcelReport,
} from './state/masterroster/actions';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { errorToast, toastInfo } from 'Common/ToastHelper';

class MasterRosterContainer extends Component {
  getMainProps = () => {
    return {
      toolbox: {
        formName: MASTER_ROSTER_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: this.props.loading,
          disabled: this.props.loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getInitialData();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      report,
      excelReport,
      clearExcelReport,
      clearReport,
      clearErrors,
    } = this.props;
    if (report && prevState !== report) {
      ReportGeneration(report, 'Master Roster Report');
      clearReport();
    }
    if (errorToast(this.props, prevProps, 'errors')) {
      clearErrors();
    }
    if (prevProps.excelReport !== excelReport) {
      //Need to do an explicit check here as the initial state is null
      if (excelReport === false) {
        toastInfo('No data found!');
      }
      clearExcelReport();
    }
  }

  handleSubmit = formValues => {
    let values = {
      ...formValues,
      [Fields.ShowSSN]: !formValues[Fields.ShowSSN], // Front end displays Show SSN back end takes HideSSN so invert it before submiting :(
    };

    // If StatusFilterMethod was chosen map the data to the format the API uses.
    if (formValues[Fields.StatusFilterMethod] === filterMethodEnums.status) {
      values = {
        ...values,
        ...formValues[Fields.Statuses].reduce((carry, status) => {
          carry[statusOptionModelParamMap[status]] = true;
          return carry;
        }, {}),
        [Fields.FilterOnly]: undefined,
      };
    }

    // If an option "ALL" was used we need to convert it to an empty string.
    for (const param in values) {
      if (values[param] === 'ALL') {
        values[param] = '';
      }
    }

    values[Fields.SiteDescription] = this.getSiteDescription(
      values[Fields.SiteId]
    );

    values[Fields.GradeDescription] = this.getGradeDescription(
      values[Fields.GradeId]
    );

    values[
      Fields.ReleaseCategoryDescription
    ] = this.getReleaseCategoryDescription(values[Fields.ReleaseCategory]);

    if (values[ReportFields.ReportFormat] === reportFormatEnum.Excel) {
      this.props.getExcelFile(values);
    } else {
      this.props.getReport(values);
    }
  };

  getSiteDescription = siteId => {
    if (!siteId) {
      return 'All';
    }
    return this.props.sites.find(({ Id }) => Id === siteId).Description;
  };

  getGradeDescription = gradeId => {
    if (!gradeId) {
      return 'All';
    }
    return this.props.grades.find(({ value }) => value === gradeId).text;
  };

  getReleaseCategoryDescription = releaseCategory => {
    if (!releaseCategory) {
      return 'All';
    }
    return this.props.releaseCategories.find(
      ({ value }) => value === releaseCategory
    ).text;
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Master Roster Report'} />
        <Main {...this.getMainProps()}>
          <MasterRosterForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.SiteId]: 'ALL',
              [Fields.StatusFilterMethod]: filterMethodEnums.status,
              [Fields.Statuses]: statusOptions.map(o => o.value),
              [Fields.GradeId]: 'ALL',
              [Fields.ReleaseCategory]: 'ALL',
              [Fields.UseAppDate]: asOfOptions[0].value,
              [Fields.ReportDT]: defaultDateFormat(moment()),
              [Fields.SortBy]: sortByOptions[0].value,
              [Fields.ProvisionType]: provisionTypeOptions.find(
                o => o.label === 'Both'
              ).value,
              [Fields.ShowSSN]: false,
              [ReportFieldEnum.ReportFormat]: reportFormatEnum.PDF,
            }}
            statusFilterMethod={this.props.statusFilterMethod}
            grades={this.props.grades}
            releaseCategories={this.props.releaseCategories}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const selector = formValueSelector(MASTER_ROSTER_FORM_NAME);
  return {
    statusFilterMethod: selector(state, [Fields.StatusFilterMethod]),
    sites: state.CommonState.sites.info.Data,
    grades: state.MasterRosterState.MasterRoster.grades,
    releaseCategories: state.MasterRosterState.MasterRoster.releaseCategories,
    loading: state.MasterRosterState.MasterRoster.fetching,
    report: state.MasterRosterState.MasterRoster.report,
    excelReport: state.MasterRosterState.MasterRoster.excelReport,
    errors: state.MasterRosterState.MasterRoster.errors,
  };
};

const mapDispatchToProps = {
  getInitialData,
  getReport,
  clearReport,
  clearErrors,
  getExcelFile,
  clearExcelReport,
};

export const MasterRoster = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MasterRosterContainer)
);



// WEBPACK FOOTER //
// ./src/pages/masterroster/MasterRoster.js